import { getShippingMethods } from 'common/api/e-comm/orders/service';
import { useApi } from 'common/modules/async-actions/useApi';

export const useShippingMethods = () => {
    const [loadShippingMethods, { loading }, shippingMethodsResult] = useApi(getShippingMethods);
    const result = shippingMethodsResult && shippingMethodsResult.data;

    return {
        loadShippingMethods,
        loading,
        shippingMethodsResponse: result,
    };
};
